<template>
  <div>
    <div class="right-toolbar" :class="{ collapsed: isCollapsed }">
      <div v-if="!isCollapsed" class="toolbar-item" @click="handleClick('consult')" title="咨询">
        <i class="el-icon-chat-dot-round"></i>
        <span>反馈群</span>
      </div>
<!--    <div v-if="!isCollapsed" class="toolbar-item" @click="handleClick('invite')" title="邀约">-->
<!--      <i class="el-icon-calendar"></i>-->
<!--      <span>邀约</span>-->
<!--    </div>-->
<!--    <div class="toolbar-item toolbar-toggle" @click="toggleToolbar" :title="isCollapsed ? '展开' : '收起'">-->
<!--      <i :class="isCollapsed ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>-->
<!--    </div>-->
    </div>

    <!-- 群号和二维码弹窗 -->
    <el-dialog
      title="加入反馈群"
      :visible.sync="dialogVisible"
      width="400px"
      center
      :close-on-click-modal="true">
      <div class="dialog-content">
        <div class="qr-section">
          <img src="../../assets/imgs/qqgroup.jpg" alt="群二维码" class="qr-code">
        </div>
        <el-button
            type="primary"
            size="small"
            @click="copyGroupNumber"
            icon="el-icon-document-copy">
          复制群号
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RightToolbar',
  data() {
    return {
      isCollapsed: false,
      dialogVisible: false,
      groupNumber: '779841732' // 这里可以替换成实际的群号
    }
  },
  methods: {
    handleClick(action) {
      console.log('点击:', action)
      if (action === 'consult') {
        this.dialogVisible = true
      } else {
        this.$message.info(`点击了${action}`)
      }
    },
    toggleToolbar() {
      this.isCollapsed = !this.isCollapsed
      console.log('工具栏状态:', this.isCollapsed ? '已收起' : '已展开')
    },
    copyGroupNumber() {
      // 创建一个临时的 textarea 元素来复制文本
      const textarea = document.createElement('textarea')
      textarea.value = this.groupNumber
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()

      try {
        document.execCommand('copy')
        this.$message.success('群号复制成功!')
      } catch (err) {
        this.$message.error('复制失败,请手动复制')
      }

      document.body.removeChild(textarea)
    }
  }
}
</script>

<style scoped>
.right-toolbar {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 1000;
  transition: all 0.3s ease;
}

.right-toolbar.collapsed {
  padding: 4px;
}

.toolbar-item {
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
  color: #6b7280;
  position: relative;
}

.toolbar-item:hover {
  background: #f3f4f6;
  color: #4f46e5;
}

.toolbar-item i {
  font-size: 20px;
}

.toolbar-item span {
  font-size: 10px;
  font-weight: 500;
}

.toolbar-toggle {
  border-top: 1px solid #e5e7eb;
  padding-top: 8px;
  margin-top: 4px;
}

.toolbar-toggle i {
  font-size: 16px;
}

/* 悬浮动画 */
.right-toolbar {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 弹窗内容样式 */
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.qr-section {
  margin-bottom: 24px;
}

.qr-code {
  width: 400px;
  height: 400px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain;
}

.group-info {
  text-align: center;
  margin-bottom: 20px;
}

.group-label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}

.group-number {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
  letter-spacing: 2px;
}

.tips {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.tips p {
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.6;
}
</style>
